module.exports = __webpack_public_path__ + "models/scene1.9f19bab.txt";